/**
 * @ngdoc directive
 * @name cbl.cartadebitoint.wa.directive:postVenditaCartaDebitoInt
 * @restrict E
 * @description Componente per la visualizzazione di una pratica di credito
 *              assicurativo
 */
(function () {
  'use strict';
  var PostVenditaCartaDebitoIntCtrl = function (
    $http,
    $scope,
    $state,
    $stateParams,
    $cacheFactory,
    CONSTANTS,
    labelSrvc,
    loggerSrvc,
    messaggiFctr,
    postVenditaCartaDebitoIntSrvc,
    domainSrvc,
    $uibModal
  ) {
    this.$http = $http;
    this.$state = $state;
    this.$stateParams = $stateParams;
    this.$cacheFactory = $cacheFactory;
    this.messaggiFctr = messaggiFctr;
    this.loggerSrvc = loggerSrvc;
    this.postVenditaCartaDebitoIntSrvc = postVenditaCartaDebitoIntSrvc;
    this.domainSrvc = domainSrvc;
    this.CONSTANTS = CONSTANTS;
    this.$uibModal = $uibModal;
    $scope.msg = labelSrvc.getLabel;
    

    /**
     * Indica se il caricamento delle labels è andato a buon fine
     */
    this.labelsPronte = false;

    /**
     * Riferimento allo spinner globale
     */
    this.spinner = this.postVenditaCartaDebitoIntSrvc.spinner;

    /**
     * Parametri passati dalla rotta ndg + id prodotto
     * Necessari per la creazione della pratica
     */
    this.ndg;

    /**
     * Tabs di primo livello
     */
    this.TAB_LIST_MACRO = [];

    /**
     * Tabs di secondo livello
     */
    this.TAB_LIST_MICRO = {};

    /**
     * Tab attivo
     */
    this.currentTabMacro = {};

    /**
     * Sottotab attivo
     */
    this.currentTabMicro = {};

    /**
     * Riferimento interno al controller per recuperare i valori nelle funzioni
     */
    var self = this;

    /**
     * ===== GESTIONE BOTTONIERA A PIÉ DI PAGINA =====
     */

    /**
     * Navigazione verso lo step precedente
     */
    this.annulla = function () {
      self.messaggiFctr.resetMessages();

      if (self.postVenditaCartaDebitoIntSrvc.idPratica) {
        self.spinner.showSpinner++;
        self.postVenditaCartaDebitoIntSrvc
          .promiseAnnullaPostVendita(self.postVenditaCartaDebitoIntSrvc.idPratica)
          .then(function (resp) {
            if (self.messaggiFctr.processaResponse(resp)) {
              return;
            }

            self.$state.go('schedaCliente', { ndg: self.ndg });
          })
          .finally(function () {
            if (self.spinner.showSpinner > 0) {
              self.spinner.showSpinner--;
            }
          });
      } else {
        self.$state.go('schedaCliente', { ndg: self.ndg });
      }
    };
    /**
     * Richiamato nelle funzioni salva e prosegui, lancia la chiamata abbinata allo stato e step pratica
     * e, se specificato, applica il flag per il solo salvataggio
     */
    this.eseguiSalvataggioStep = function (prosegui) {
      var stato = null;
      var step = null;

      // Recupero la prima combinazione, poiché la chiamate per completare ogni tab sono le solite
      if (self.currentTabMicro) {
        stato = self.currentTabMicro.statoPratica[0].stato;
        step = self.currentTabMicro.statoPratica[0].step;
      } else {
        stato = self.currentTabMacro.statoPratica[0].stato;
        step = self.currentTabMacro.statoPratica[0].step;
      }

      // devo switchare in base al codice funzione
      switch (stato) {
        case CONSTANTS.STATO_PRATICA.IN_CORSO:
        case CONSTANTS.STATO_PRATICA.DAREVISIONARE:
          // A seconda della specializzazione le chiamate da eseguire sono diverse
          switch (self.postVenditaCartaDebitoIntSrvc.currentFunzione) {
            case CONSTANTS.FUNZIONI.ATTIVA_BLOCCO:
            case CONSTANTS.FUNZIONI.RIMUOVI_BLOCCO:
            case CONSTANTS.FUNZIONI.MOD_INTESTA:
            case CONSTANTS.FUNZIONI.MOD_CONDIZIONI:
            case CONSTANTS.FUNZIONI.MOD_LIMITI:
            case CONSTANTS.FUNZIONI.MOD_CONTO:
            case CONSTANTS.FUNZIONI.MOD_INDIRIZZO:
              switch (step) {
                case 1:
                  self.avanzaPratica(prosegui, true);
                  break;
              }
              break;
            // sono tutti riconducibili alla stessa funzione.
            case CONSTANTS.FUNZIONI.RIMUOVI_BLOCCO:
            case CONSTANTS.FUNZIONI.DUP_CARTA:
            case CONSTANTS.FUNZIONI.RIF_CARTA:
              switch (step) {
                case 1:
                  self.rimuovi_blocco(prosegui, self.postVenditaCartaDebitoIntSrvc.currentFunzione, true);
                  break;
              }
              break;
          }
          break;
      }
    };

    /**
     * Salvataggio dello stato della pratica
     */
    this.salva = function () {
      self.messaggiFctr.resetMessages();

      self.loggerSrvc.log(
        'PostVenditaCartaDebitoIntCtrl',
        self.loggerSrvc.INFO,
        'Salvataggio della pratica ID ' +
          self.postVenditaCartaDebitoIntSrvc.idPratica +
          ': stato attuale ' +
          self.postVenditaCartaDebitoIntSrvc.datiPratica.stato
      );

      self.eseguiSalvataggioStep(false);
    };

    /**
     * Proseguimento allo step successivo della pratica
     * O, se ci troviamo all'ultimo step, completamento
     */
    this.avanza = function () {
      self.messaggiFctr.resetMessages();

      if (
        self.postVenditaCartaDebitoIntSrvc.currentCarta &&
        (self.postVenditaCartaDebitoIntSrvc.currentCarta.stato === 'EL' ||
          (self.postVenditaCartaDebitoIntSrvc.currentFunzione === CONSTANTS.FUNZIONI.MOD_CONTO &&
            self.postVenditaCartaDebitoIntSrvc.currentCarta.cartalight))
      ) {
        self.messaggiFctr.addMessage({
          type: 'E',
          message: $scope.msg('label.errors.cartaNonAmmessa')
        });
        return;
      }

      self.loggerSrvc.log(
        'PostVenditaCartaDebitoIntCtrl',
        self.loggerSrvc.INFO,
        'Avanzamento di step per ndg ' +
          self.ndg +
          ': funzione ' +
          self.postVenditaCartaDebitoIntSrvc.currentFunzione +
          ': carta selezionata ' +
          self.postVenditaCartaDebitoIntSrvc.currentCarta
      );

      self.eseguiSalvataggioStep(true);
    };

    /**
     * Funzione eseguita dal prosegui del primo step, conferma il prodotto abbinato alla pratica
     */
    this.rimuovi_blocco = function (prosegui, funzione, inviaDatiPG) {
      self.loggerSrvc.log(
        'PostVenditaCartaDebitoIntCtrl',
        self.loggerSrvc.INFO,
        'Conferma rimuovi blocco carta ' + self.postVenditaCartaDebitoIntSrvc.currentCarta
      );

      self.spinner.showSpinner++;

      if (prosegui) {
        self.resetAbilitazioni();
        self.attivaTabPerStatoPratica();
      }

      if (self.spinner.showSpinner > 0) {
        self.spinner.showSpinner--;
      }

      self.postVenditaCartaDebitoIntSrvc.datiPratica = {
        stato: 'INCORSO',
        step: 2
      };
    };

    /**
     * Function applicata al click su indietro. Essendo 2 tab riporto lo stato a step 1 indipendentemente da dove mi trovo
     */
    this.indietro = function () {
      self.postVenditaCartaDebitoIntSrvc.datiPratica = {
        stato: 'INCORSO',
        step: 1
      };
      self.currentTabMacro = self.TAB_LIST_MACRO[0];
      self.currentTabMicro = self.TAB_LIST_MICRO[0];
    };

    /**
     * Funzione eseguita dal prosegui del primo step, conferma il prodotto abbinato alla pratica
     */
    this.avanzaPratica = function (prosegui) {
      self.loggerSrvc.log(
        'PostVenditaCartaDebitoIntCtrl',
        self.loggerSrvc.INFO,
        'avanzamento pratica ' +
          self.postVenditaCartaDebitoIntSrvc.currentCarta +
          'funzione ' +
          self.postVenditaCartaDebitoIntSrvc.currentFunzione
      );

      self.spinner.showSpinner++;

      self.postVenditaCartaDebitoIntSrvc.datiPratica = {
        stato: 'INCORSO',
        step: 2
      };
      if (prosegui) {
        self.resetAbilitazioni();
        self.attivaTabPerStatoPratica();
      }

      if (self.spinner.showSpinner > 0) {
        self.spinner.showSpinner--;
      }
    };

    /**
     * Funzione che verifica se il tab specificato è abilitato per lo stato/step indicati
     * Step può essere null, in quel caso sarà verificato solo lo stato
     */
    this.tabContieneStatoStep = function (tab, stati, step) {
      if (!(tab && tab.statoPratica)) {
        return false;
      }

      if (!(stati && stati.length > 0)) {
        return false;
      }

      for (var i = 0; i < tab.statoPratica.length; i++) {
        if (stati.indexOf(tab.statoPratica[i].stato) > -1 && (!step || tab.statoPratica[i].step === step)) {
          return true;
        }
      }

      return false;
    };

    this.completaPratica = function () {
      // recupero i dati in base allo step e alla funzione e creo la pratica.ab-last-read
      self.spinner.showSpinner++;

      //QUID-27 richiesto controllo su tipologia Light del cc, al momento non implementabile per mancanza informazione
      //      if(self.postVenditaCartaDebitoIntSrvc.currentFunzione === CONSTANTS.FUNZIONI.MOD_CONTO
      //    		  && self.postVenditaCartaDebitoIntSrvc.currentCarta.cartalight){
      //    	  self.messaggiFctr.addMessage({
      //              type: 'E',
      //              message: $scope.msg('label.errors.cartaNonAmmessa')
      //            });
      //    	  if (self.spinner.showSpinner > 0) {
      //              self.spinner.showSpinner--;
      //            }
      //    	  return;
      //      }
      if(self.postVenditaCartaDebitoIntSrvc.currentFunzione === CONSTANTS.FUNZIONI.MOD_INDIRIZZO){
    	  self.postVenditaCartaDebitoIntSrvc.datiAggiuntivi.indirizzoSpedizione.via = self.postVenditaCartaDebitoIntSrvc.datiAggiuntivi.indirizzoSpedizione.via.toUpperCase();
    	  if(self.postVenditaCartaDebitoIntSrvc.datiAggiuntivi.indirizzoSpedizione.presso){
    		  self.postVenditaCartaDebitoIntSrvc.datiAggiuntivi.indirizzoSpedizione.presso = self.postVenditaCartaDebitoIntSrvc.datiAggiuntivi.indirizzoSpedizione.presso.toUpperCase();
    		  self.postVenditaCartaDebitoIntSrvc.datiAggiuntivi.indirizzoSpedizione.presso = self.postVenditaCartaDebitoIntSrvc.datiAggiuntivi.indirizzoSpedizione.presso.replace('C/O ', ' ').replace(' C/O ', ' ').replace(' CO ', ' ');
    	  }
      }

      return self.postVenditaCartaDebitoIntSrvc
        .promiseCreaPratica(
          self.postVenditaCartaDebitoIntSrvc.ndg,
          self.postVenditaCartaDebitoIntSrvc.currentCarta.numeroCarta,
          self.postVenditaCartaDebitoIntSrvc.currentFunzione,
          // verifico in base a funzione
          // MDOCONTO
          self.postVenditaCartaDebitoIntSrvc.currentFunzione === CONSTANTS.FUNZIONI.MOD_CONTO
            ? self.postVenditaCartaDebitoIntSrvc.currentConto.iban
            : null,
          // NUOVA INTESTAZIONE
          self.postVenditaCartaDebitoIntSrvc.currentFunzione === CONSTANTS.FUNZIONI.MOD_INTESTA
            ? self.postVenditaCartaDebitoIntSrvc.datiAggiuntivi.nuovaIntestazione
            : null,
          // ATTIVA BLOCCO
          self.postVenditaCartaDebitoIntSrvc.currentFunzione === CONSTANTS.FUNZIONI.ATTIVA_BLOCCO
            ? self.postVenditaCartaDebitoIntSrvc.currentBlocco
            : null,
          // MODIFICA CONDIZIONI
          self.postVenditaCartaDebitoIntSrvc.currentFunzione === CONSTANTS.FUNZIONI.MOD_CONDIZIONI
            ? self.postVenditaCartaDebitoIntSrvc.datiAggiuntivi.importoQuota
            : null,
          self.postVenditaCartaDebitoIntSrvc.currentFunzione === CONSTANTS.FUNZIONI.MOD_CONDIZIONI
            ? self.postVenditaCartaDebitoIntSrvc.datiAggiuntivi.condizione
            : null,
          // MODIFICA LIMITI
          self.postVenditaCartaDebitoIntSrvc.currentFunzione === CONSTANTS.FUNZIONI.MOD_LIMITI
            ? self.postVenditaCartaDebitoIntSrvc.datiAggiuntivi.limiteGiornaliero
            : null,
          self.postVenditaCartaDebitoIntSrvc.currentFunzione === CONSTANTS.FUNZIONI.MOD_LIMITI
            ? self.postVenditaCartaDebitoIntSrvc.datiAggiuntivi.limiteMensile
            : null,
          self.postVenditaCartaDebitoIntSrvc.currentFunzione === CONSTANTS.FUNZIONI.MOD_LIMITI
            ? self.postVenditaCartaDebitoIntSrvc.datiAggiuntivi.limiteDownoption
            : null,
          self.postVenditaCartaDebitoIntSrvc.idPratica,
          self.postVenditaCartaDebitoIntSrvc.currentCarta.cartalight,
          self.postVenditaCartaDebitoIntSrvc.currentFunzione === CONSTANTS.FUNZIONI.MOD_CONTO
            ? self.postVenditaCartaDebitoIntSrvc.currentConto.numeroRapporto
            : null,
          self.postVenditaCartaDebitoIntSrvc.currentFunzione === CONSTANTS.FUNZIONI.MOD_INDIRIZZO
            ? self.postVenditaCartaDebitoIntSrvc.datiAggiuntivi.indirizzoSpedizione
            : null
        )
        .then(
          function (response) {
            if (self.messaggiFctr.processaResponse(response)) {
              return;
            }
            self.$state.go('schedaCliente', { ndg: self.ndg });
          },
          function (reason) {
            self.messaggiFctr.processaResponse(reason);
          }
        )
        .finally(function () {
          if (self.spinner.showSpinner > 0) {
            self.spinner.showSpinner--;
          }
        });
    };

    /**
     * Reimposta le funzioni di abilitazione e visualizzazione dei pulsanti a pié di pagina
     */
    this.resetAbilitazioni = function () {
      self.postVenditaCartaDebitoIntSrvc.indietroAbilitato =
        self.postVenditaCartaDebitoIntSrvc.defaultIndietroAbilitato;
      self.postVenditaCartaDebitoIntSrvc.salvaVisibile = self.postVenditaCartaDebitoIntSrvc.defaultSalvaVisibile;
      self.postVenditaCartaDebitoIntSrvc.salvaAbilitato = self.postVenditaCartaDebitoIntSrvc.defaultSalvaAbilitato;
      self.postVenditaCartaDebitoIntSrvc.proseguiAbilitato =
        self.postVenditaCartaDebitoIntSrvc.defaultProseguiAbilitato;
    };

    this.resetDatiPratica = function () {
      self.postVenditaCartaDebitoIntSrvc.datiPratica = null;
    };

    /**
     * @ngdoc method
     * @name macroTabClicked
     * @methodOf cbl.cartadebitoint.wa.directive:cdintPropostaCartaDebitoInt
     * @description Gestisce il click sulle macro tab
     * @param {Object} tab: l'oggetto tab selezionato
     */
    this.macroTabClicked = function (tab) {
      if (!self.postVenditaCartaDebitoIntSrvc.isPraticaNavigabile()) {
        return;
      }

      self.currentTabMacro = tab;

      // Verifico se il tab ha sotto-tab
      if (self.TAB_LIST_MICRO[self.currentTabMacro.step] && self.TAB_LIST_MICRO[self.currentTabMacro.step].length > 0) {
        self.currentTabMicro = self.TAB_LIST_MICRO[self.currentTabMacro.step][0];
      } else {
        self.currentTabMicro = null;
      }
    };

    /**
     * @ngdoc method
     * @name getStyleTabMacro
     * @methodOf cbl.cartadebitoint.wa.directive:cdintPropostaCartaDebitoInt
     * @description Imposta lo stile di visualizzazione per gli indicatori dei macro step
     * @param {number} currentTabIndex - L'indice della tab cui applicare lo stile
     * @return {string} - Restituisce lo stile da applicare all'indicatore del macro step
     */
    this.getStyleTabMacro = function (currentTabIndex) {
      // Pratica non navigabile
      if (currentTabIndex < self.currentTabMacro.index) {
        return 'progress-pass';
      }

      if (currentTabIndex === self.currentTabMacro.index) {
        return 'progress-current';
      }

      return 'progress-next';
    };

    /**
     * @ngdoc method
     * @name getStyleTabMacroReadOnly
     * @methodOf cbl.cartadebitoint.wa.directive:cdintPropostaCartaDebitoInt
     * @description Imposta lo stile di visualizzazione per gli indicatori dei macro step in modalità sola lettura
     * @param {number} currentTabIndex - L'indice della tab cui applicare lo stile
     * @return {string} - Restituisce lo stile da applicare all'indicatore del macro step
     */
    this.getStyleTabMacroReadOnly = function (currentTabIndex) {
      if (currentTabIndex < self.currentTabMacro.index) {
        return 'progress-next-read';
      }

      if (currentTabIndex === self.currentTabMacro.index) {
        return 'progress-current-read';
      }

      return 'progress-next-read';
    };

    /**
     * In base allo step definito nel tab, recupera l'URL del template da visualizzare
     */
    this.getStepUrl = function (step) {
      switch (step) {
        case 'DEFINIZIONE':
          return 'definizione.tmpl.html';
        case 'DATIAGGIUNTIVI':
          return 'datiAggiuntivi.tmpl.html';
        default:
          return null;
      }
    };

    /**
     * Funzione che dopo il recupero dei tab o dopo un cambio stato evidenzia il tab attivo
     * in base allo stato della pratica
     */
    this.attivaTabPerStatoPratica = function () {
      if (self.postVenditaCartaDebitoIntSrvc.datiPratica) {
        if (
          self.postVenditaCartaDebitoIntSrvc.datiPratica &&
          self.postVenditaCartaDebitoIntSrvc.datiPratica.stato &&
          self.postVenditaCartaDebitoIntSrvc.datiPratica.step
        ) {
          // Se la pratica è in stato di ACCETTATA apro direttamente
          // la prima tab e primo step visto che il wizard è navigabile
          if (self.postVenditaCartaDebitoIntSrvc.datiPratica.stato === CONSTANTS.STATO_PRATICA.ACCETTATA) {
            self.currentTabMacro = self.TAB_LIST_MACRO[0];
            self.currentTabMicro = self.TAB_LIST_MICRO[0];
            return;
          }

          // Nel caso di pratica consolidata devo valutare solamente lo stato
          // Negli altri casi tutto il resto
          for (var i = 0; i < self.TAB_LIST_MACRO.length; i++) {
            var macroTab = self.TAB_LIST_MACRO[i];
            // Verifico se ho dei sotto-tab
            // In caso positivo imposto sia il macro-tab che il micro-tab
            if (!macroTab.statoPratica && self.TAB_LIST_MICRO[macroTab.step]) {
              for (var j = 0; j < self.TAB_LIST_MICRO[macroTab.step].length; j++) {
                var microTab = self.TAB_LIST_MICRO[macroTab.step][j];
                if (
                  self.tabContieneStatoStep(
                    microTab,
                    [self.postVenditaCartaDebitoIntSrvc.datiPratica.stato],
                    self.postVenditaCartaDebitoIntSrvc.datiPratica.step
                  )
                ) {
                  self.currentTabMacro = macroTab;
                  self.currentTabMicro = microTab;

                  self.loggerSrvc.log(
                    'PostVenditaCartaDebitoIntCtrl',
                    self.loggerSrvc.INFO,
                    'Apertura tab ' +
                      self.currentTabMacro.title +
                      '/' +
                      self.currentTabMicro.title +
                      ' per pratica ID ' +
                      self.postVenditaCartaDebitoIntSrvc.idPratica
                  );
                  return;
                }
              }

              continue;
            }

            // Altrimenti solo il macro-tab
            if (
              self.tabContieneStatoStep(
                macroTab,
                [self.postVenditaCartaDebitoIntSrvc.datiPratica.stato],
                self.postVenditaCartaDebitoIntSrvc.datiPratica.step
              )
            ) {
              self.currentTabMacro = macroTab;
              self.currentTabMicro = null;

              self.loggerSrvc.log(
                'PostVenditaCartaDebitoIntCtrl',
                self.loggerSrvc.INFO,
                'Apertura tab ' +
                  self.currentTabMacro.title +
                  ' per pratica ID ' +
                  self.postVenditaCartaDebitoIntSrvc.idPratica
              );

              return;
            }
          }
        }

        self.currentTabMacro = self.TAB_LIST_MACRO[0];
      }
      // attivo il tab iniziale
      if (!!self.currentTabMacro) {
        self.currentTabMacro = self.TAB_LIST_MACRO[0];
        self.currentTabMicro = null;
      }
    };

    /**
     * Funzione richiamata dopo il caricamento della pratica, recupera le tabs disponibili
     */
    this.recuperaTabs = function () {
      // Genera le tab passando un boolean che indica se c'è una seconda tab o no
      // Per il momento la seconda tab c'è solo se la funzione selezionata è blocco o cambio conto
      var tabs = self.postVenditaCartaDebitoIntSrvc.generaTabs(
        !self.postVenditaCartaDebitoIntSrvc.currentFunzione ||
          self.postVenditaCartaDebitoIntSrvc.currentFunzione === 'APLBLC' ||
          self.postVenditaCartaDebitoIntSrvc.currentFunzione === 'MODCNT' ||
          self.postVenditaCartaDebitoIntSrvc.currentFunzione === 'MODIND'
      );

      self.TAB_LIST_MACRO = [];
      self.TAB_LIST_MICRO = {};

      // Costruzione tabs
      var tabData = null;
      var subtabData = null;
      for (var i = 0; i < tabs.length; i++) {
        tabData = tabs[i];
        subtabData = null;

        self.TAB_LIST_MACRO.push({
          index: i,
          step: tabData.step,
          title: tabData.posizione + ' ' + $scope.msg(tabData.label),
          url: self.getStepUrl(tabData.step),
          statoPratica: tabData.statoPratica
        });

        // Costruzione sotto-tabs, se presenti
        if (tabData.sottoStep && tabData.sottoStep.length > 0) {
          self.TAB_LIST_MICRO[tabData.step] = [];

          for (var j = 0; j < tabData.sottoStep.length; j++) {
            subtabData = tabData.sottoStep[j];

            self.TAB_LIST_MICRO[tabData.step].push({
              index: j,
              step: subtabData.step,
              title: tabData.posizione + '.' + subtabData.posizione + ' ' + $scope.msg(subtabData.label),
              url: self.getStepUrl(subtabData.step),
              statoPratica: subtabData.statoPratica
            });
          }
        }
      }
      self.attivaTabPerStatoPratica();
    };

    // Al cambio di funzione (segnalato con emit) si cambia le tab
    $scope.$on('onFunzioneChange', function () {
      self.recuperaTabs();
    });

    /**
     *  Funzione richiamata all'avvio del controller
     */
    this.init = function () {
      // Forzatura per lo spegnimento dello spinner generale dell'applicazione per poter gestire
      // correttamente quello locale.
      var overlay = document.getElementById('overlay');
      if (!!overlay) {
        overlay.setAttribute('style', 'display: none;');
      }

      self.resetAbilitazioni();

      self.resetDatiPratica();

      labelSrvc.labelsPronte.then(function () {
        self.labelsPronte = true;

        self.postVenditaCartaDebitoIntSrvc.resetData();
        /**
         * rotta con solo ndg non c'e' un wf della pratica.
         */
        if (self.$stateParams.ndg) {
          self.ndg = self.$stateParams.ndg;
          self.postVenditaCartaDebitoIntSrvc.ndg = self.ndg;

          // Recupero le tab all'init
          self.recuperaTabs();
          return;
        }

        /**
         * Caso di nessun parametro passato
         */
        self.messaggiFctr.addMessage({
          type: 'E',
          message: $scope.msg('label.errors.parametersNotReceived')
        });
        self.loggerSrvc.log(
          'PostVenditaCartaDebitoIntCtrl',
          self.loggerSrvc.SEVERE,
          $scope.msg('label.errors.parametersNotReceived')
        );
      });
    };

    self.init();
  };

  PostVenditaCartaDebitoIntCtrl.$inject = [
    '$http',
    '$scope',
    '$state',
    '$stateParams',
    '$cacheFactory',
    'CDINT_CONSTANTS',
    'CdintLabelSrvc',
    'CdintLoggerSrvc',
    'CdintMessaggiFctr',
    'PostVenditaCartaDebitoIntSrvc',
    '$uibModal'
  ];

  var TemplateUrl = function (CONSTANTS) {
    return CONSTANTS.BASE_ROOT + CONSTANTS.COMPONENTS_PATH + 'postVenditaCartaDebitoInt/postVenditaCartaDebitoInt.html';
  };

  TemplateUrl.$inject = ['CDINT_CONSTANTS'];

  var PostVenditaCartaDebitoIntComponent = {
    controller: PostVenditaCartaDebitoIntCtrl,
    controllerAs: 'postVenditaCtrl',
    templateUrl: TemplateUrl
  };

  angular.module('cbl.cartadebitoint.wa').component('postVenditaCartaDebitoInt', PostVenditaCartaDebitoIntComponent);
})();



//////////////////
// WEBPACK FOOTER
// ./app/components/postVenditaCartaDebitoInt/postVenditaCartaDebitoInt.cmpt.js
// module id = 18
// module chunks = 0